export enum NotificationType {
    ERROR = 0,
    WARNING = 1,
    SUCCESS = 2,
}